<div class="ock-add" fxFlex.lt-md="100" fxLayout="column" fxLayoutGap="15px" [formGroup]="ockForm">
  <div fxLayout="row" fxLayoutGap="30px">
    <div *ngIf="!addUserAccount" fxLayout="column" fxLayoutAlign="start none" fxFlex="35" fxLayoutGap="0px">
      <h3>Dane firmy</h3>
      <app-detail header="Firma" [value]="partnerObject.fullName"></app-detail>
      <app-detail header="Adres">
        {{ partnerObject.headquartersAddress.street }} {{ partnerObject.headquartersAddress.houseNumber }}
        {{ partnerObject.headquartersAddress.apartmentNumber ? '/' + partnerObject.headquartersAddress.apartmentNumber : '' }}
        ,
        {{ partnerObject.headquartersAddress.zipCode }} {{ partnerObject.headquartersAddress.city }}
      </app-detail>
      <app-detail header="NIP" [value]="partnerObject.nip"></app-detail>
      <app-detail header="REGON" [value]="partnerObject.regon"></app-detail>
      <app-detail header="PKD główne" [value]="partnerObject.mainPKDCode"></app-detail>
      <app-detail header="PKD pozostałe" [value]="partnerObject.pkdCode"></app-detail>

    </div>
    <div fxLayout="column" fxLayoutAlign="start none" [fxFlex]="addUserAccount ? 100 : 75" fxLayoutGap="10px">
      <div><h3>Dodaj konto OCK <span
        class="text-gray text-sm">{{ addUserAccount ? '(Konto użytkownika)' : '(Konto główne)' }}</span></h3></div>
      <div fxLayout="row" fxLayoutGap="15px">
        <mat-form-field fxFlex="33">
          <mat-label>Imię</mat-label>
          <input matInput placeholder="Jan" formControlName="firstName" [required]="true">
          <mat-error *ngIf="ockForm.get('firstName').hasError('required')">To pole jest wymagane</mat-error>
        </mat-form-field>

        <mat-form-field fxFlex="33">
          <mat-label>Nazwisko</mat-label>
          <input matInput placeholder="Kowalski" formControlName="lastName" [required]="true">
          <mat-error *ngIf="ockForm.get('lastName').hasError('required')">To pole jest wymagane</mat-error>
        </mat-form-field>
        <mat-form-field fxFlex="33">
          <mat-label>PESEL</mat-label>
          <input matInput placeholder="PESEL" formControlName="pesel" [required]="true">
          <mat-error *ngIf="ockForm.get('pesel').hasError('required')">To pole jest wymagane</mat-error>
          <mat-error *ngIf="ockForm.get('pesel').hasError('invalidPesel')">Podaj prawidłowy numer PESEL</mat-error>
          <mat-error *ngIf="ockForm.get('pesel').hasError('backendError')">{{ formErrors.pesel }}</mat-error>
          <mat-error *ngIf="ockForm.get('pesel').hasError('peselExists')">Konto z tym numerem PESEL już istnieje</mat-error>
        </mat-form-field>
      </div>
      <div fxLayout="column" fxLayoutGap="0px">

        <mat-form-field fxFlex="100">
          <mat-label>Numer telefonu</mat-label>
          <input matInput placeholder="+48500600200 (bez spacji)" formControlName="phoneNumber" [required]="true"
                 prefix="+48" mask=" 000 000 000">
          <mat-error *ngIf="ockForm.get('phoneNumber').hasError('required')">To pole jest wymagane</mat-error>
          <mat-error *ngIf="ockForm.get('phoneNumber').hasError('invalidPhoneNumber')">Podaj prawidłowy numer telefonu
          </mat-error>
        </mat-form-field>
        <div>
          <mat-chip-list
            class="example-chip"
            cdkDropList
            cdkDropListOrientation="horizontal"
            (cdkDropListDropped)="phoneDropList($event, partnerObject.phones)">
            <ng-container *ngFor="let phoneNumber of partnerObject.phones">
              <mat-chip
                *ngIf="!isPhoneNumberOckAccounts(phoneNumber.number)"
                class="cursor-pointer"
                cdkDrag
                (click)="selectPhone(phoneNumber)"
              >
                {{ phoneNumber.number | phone }} {{ phoneNumber.name ? ' (' + phoneNumber.name + ')' : '' }}
              </mat-chip>
            </ng-container>
          </mat-chip-list>
        </div>
      </div>

      <div fxLayout="column" fxLayoutGap="0px">
        <mat-form-field fxFlex="100">
          <mat-label>Email</mat-label>
          <input matInput placeholder="adres@mail.pl" formControlName="email" [required]="true">
          <mat-error *ngIf="ockForm.get('email').hasError('required')">To pole jest wymagane</mat-error>
          <mat-error *ngIf="ockForm.get('email').hasError('email')">Podaj prawidłowy adres email</mat-error>
          <mat-error *ngIf="ockForm.get('email').hasError('loginExists')">Konto z tym adresem email już istnieje</mat-error>
        </mat-form-field>
        <div>
          <mat-chip-list
            class="example-chip"
            cdkDropList
            cdkDropListOrientation="horizontal"
            (cdkDropListDropped)="emailDropList($event, partnerObject.emails)">
            <ng-container *ngFor="let email of partnerObject.emails">
              <mat-chip
                *ngIf="!isEmailInOckAccounts(email.address)"
                class="cursor-pointer"
                cdkDrag
                (click)="selectEmail(email)">
                {{ email.address }} {{ email.name ? ' (' + email.name + ')' : '' }}
              </mat-chip>
            </ng-container>
          </mat-chip-list>
        </div>
      </div>

      <!--      <div fxLayout="column" fxLayoutGap="0px">-->
      <!--&lt;!&ndash;        <ng-container *ngFor="let email of partnerObject.emails">&ndash;&gt;-->
      <!--&lt;!&ndash;          <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="start center">&ndash;&gt;-->
      <!--&lt;!&ndash;            <mat-checkbox&ndash;&gt;-->
      <!--&lt;!&ndash;              fxFlex="none"&ndash;&gt;-->
      <!--&lt;!&ndash;              (click)="$event.stopPropagation()"&ndash;&gt;-->
      <!--&lt;!&ndash;              (change)="$event ? selection.toggle(email) : null"&ndash;&gt;-->
      <!--&lt;!&ndash;              [checked]="selectEmail(email.uuid)"&ndash;&gt;-->
      <!--&lt;!&ndash;              [aria-label]="checkboxLabel(email)">&ndash;&gt;-->
      <!--&lt;!&ndash;            </mat-checkbox>&ndash;&gt;-->
      <!--&lt;!&ndash;            <app-detail fxFlex="100" header="Adres">{{email.address}} {{email.name ? ' (' + email.name  + ')': ''}}</app-detail>&ndash;&gt;-->
      <!--&lt;!&ndash;          </div>&ndash;&gt;-->
      <!--&lt;!&ndash;        </ng-container>&ndash;&gt;-->
      <!--      </div>-->

    </div>
  </div>
  <div class="mt-15" fxLayout="row" fxLayoutAlign="end center" fxFlex="100" fxLayoutGap="15px"
       style="margin-top: auto;">
    <mat-slide-toggle [formControl]="ockAccountsVerificationControl"
                      color="accent">{{ addUserAccount ? 'Weryfikacja użytkownika' : 'Weryfikacja partnera' }}
    </mat-slide-toggle>
    <button
      [disabled]="ockAccountsVerificationControl.value !== true"
      (click)="sendForm()"
      [class.spinner]="processingRequest"
      mat-stroked-button
      color="primary">
      <mat-icon>save</mat-icon>
      <span>Dodaj konto</span>
    </button>
    <button (click)="closeDialog($event)" mat-stroked-button color="warn">
      <mat-icon>cancel</mat-icon>
      <span>Anuluj</span>
    </button>
  </div>
</div>
